/* =========================================================
   ALLURECART — storefront behaviour
   Talks to the real Shopify cart (/cart.js, /cart/add.js,
   /cart/change.js). Config comes from window.ACConfig,
   written by layout/theme.liquid from theme settings.
   ========================================================= */
(function () {
  'use strict';

  var CFG = window.ACConfig || {};
  var cart = null;                 // last cart.js payload
  var busy = false;

  /* ---------- money ---------- */
  function fmt(cents) {
    var fmtStr = CFG.moneyFormat || '${{amount}}';
    var v = (cents / 100);
    function withComma(n, dec) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmtStr
      .replace(/\{\{\s*amount\s*\}\}/g, withComma(v, 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withComma(v, 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma(v, 2).replace(/,/g, ' ').replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma(v, 0).replace(/,/g, ' '));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    if (drawerOpen()) return;                       // the drawer already shows the change
    var t = $('#ac-toast'); if (!t) return;
    $('#ac-toastMsg').textContent = msg;
    t.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('on'); }, 2100);
  }

  /* ---------- cart api ---------- */
  function getCart() {
    return fetch(CFG.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function addItems(items) {
    return fetch(CFG.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }
  /* change.js and update.js both answer with the WHOLE cart, so anything that goes
     through them needs no follow-up GET. That is most of the speed win here. */
  function changeLine(key, qty) {
    return fetch(CFG.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }
  function updateCart(updates) {
    return fetch((CFG.routes.cart_update_url || (CFG.routes.cart_url + '/update')) + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  /* Adding used to cost three round trips: add.js, then a GET to learn the new cart,
     then more calls to settle gifts. update.js takes absolute quantities AND answers
     with the whole cart, so the same add is one request. No line in this theme carries
     line-item properties, which is what makes addressing lines by variant id safe.
     Falls back to add.js before the first cart load, when we can't know current counts. */
  function addItems2(items) {
    if (!cart) return addItems(items).then(getCart);
    var have = {};
    cart.items.forEach(function (li) { have[li.variant_id] = (have[li.variant_id] || 0) + li.quantity; });
    var updates = {};
    items.forEach(function (it) {
      if (updates[it.id] === undefined) updates[it.id] = have[it.id] || 0;
      updates[it.id] += it.quantity;
    });
    return updateCart(updates);
  }

  /* Dim prices while a request is in flight, so a tap reads as "working", not "broken". */
  function setBusy(on) {
    var d = $('#ac-drawer');
    if (d) d.classList.toggle('ac-busy', !!on);
  }

  /* Reconcile automatic lines: free gifts by threshold, shipping protection by toggle.
     Runs one pass — gifts cost 0 so adding them can't retrigger a threshold. */
  function reconcile(c) {
    var sub = qualifyingSubtotal(c);
    var wanted = {};                                 // variantId -> qty
    (CFG.gifts || []).forEach(function (g) {
      if (g.variant && sub >= g.threshold) wanted[g.variant] = 1;
    });
    /* Shipping protection only exists alongside something to protect. This also means
       emptying the cart strips it, instead of leaving a lone $2.99 line behind. */
    if (CFG.protection && CFG.protection.variant && protectOn() && cartShape(c).coreCount > 0) {
      wanted[CFG.protection.variant] = 1;
    }

    var managed = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) managed[g.variant] = true; });
    if (CFG.protection && CFG.protection.variant) managed[CFG.protection.variant] = true;

    /* One update.js call fixes every managed line at once — it used to be a request
       per gift plus a re-fetch, which is what made the cart feel laggy. Gifts and the
       protection fee carry no line properties, so addressing them by variant is safe. */
    var have = {};
    c.items.forEach(function (li) {
      if (managed[li.variant_id]) have[li.variant_id] = (have[li.variant_id] || 0) + li.quantity;
    });

    var updates = {}, changed = false;
    Object.keys(managed).forEach(function (id) {
      var want = wanted[id] ? 1 : 0;
      if ((have[id] || 0) !== want) { updates[id] = want; changed = true; }
    });

    if (!changed) return Promise.resolve(c);
    return updateCart(updates).then(function (c2) { return c2 && c2.items ? c2 : c; });
  }

  /* Paint what we already know first, then settle the automatic lines. The drawer
     opens on the tap, not after the network. */
  function paintCart(c) {
    cart = c;
    renderCart();
    bump();
    gateCartPage();
  }

  function refresh(showDrawer) {
    if (showDrawer) openDrawer();
    setBusy(true);
    return getCart().then(function (c) {
      paintCart(c);
      return reconcile(c);
    }).then(function (c) {
      if (c !== cart) paintCart(c);
      setBusy(false);
      return c;
    }, function (e) { setBusy(false); throw e; });
  }

  /* ---------- shipping protection preference ---------- */
  function protectOn() {
    if (!CFG.protection || !CFG.protection.variant) return false;
    var v = null;
    try { v = localStorage.getItem('ac_protect'); } catch (e) {}
    if (v === null) return CFG.protection.defaultOn !== false;
    return v === '1';
  }
  function setProtect(on) {
    try { localStorage.setItem('ac_protect', on ? '1' : '0'); } catch (e) {}
  }

  /* ---------- badges ---------- */
  function bump() {
    var n = cart ? cart.item_count : 0;
    $$('.ac-badge').forEach(function (b) { b.textContent = n; b.dataset.n = n; });
  }

  /* ---------- drawer ---------- */
  function drawerOpen() { var d = $('#ac-drawer'); return d && d.classList.contains('on'); }
  function openDrawer() {
    $('#ac-drawer').classList.add('on');
    $('#ac-drawer').setAttribute('aria-hidden', 'false');
    $('#ac-scrim').classList.add('on');
    document.body.classList.add('ac-locked');
  }
  function closeDrawer() {
    $('#ac-drawer').classList.remove('on');
    $('#ac-drawer').setAttribute('aria-hidden', 'true');
    if (!$('#ac-chat').classList.contains('on')) $('#ac-scrim').classList.remove('on');
    document.body.classList.remove('ac-locked');
  }

  /* Subtotal that counts toward the reward ladder: everything except the
     auto-added free gifts and the shipping-protection line. */
  /* What the reward ladder measures. Order-level automatic discounts never reach
     final_line_price — they only show up in cart.total_price — so measuring lines
     alone handed out a $199 gift to someone paying $178. */
  function qualifyingSubtotal(c) {
    var skip = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) skip[g.variant] = true; });
    if (CFG.protection && CFG.protection.variant) skip[CFG.protection.variant] = true;

    var lineSum = 0, listSum = 0, skipped = 0;
    c.items.forEach(function (li) {
      if (skip[li.variant_id]) { skipped += li.final_line_price; return; }
      lineSum += li.final_line_price;
      listSum += li.original_line_price != null ? li.original_line_price : li.final_line_price;
    });

    if (CFG.rewardBasis === 'before') return listSum;

    var total = typeof c.total_price === 'number' ? c.total_price : lineSum + skipped;
    return Math.max(0, Math.min(total - skipped, lineSum));
  }

  /* Cart makeup, used by both the protection rule and the checkout gate.
     "core" = a real product: not a free gift, not the protection fee, not a spare. */
  function cartShape(c) {
    var skip = {}, addon = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) skip[g.variant] = true; });
    if (CFG.protection && CFG.protection.variant) skip[CFG.protection.variant] = true;
    (CFG.addons || []).forEach(function (a) { addon[a.id] = true; });
    var coreCount = 0, coreSubtotal = 0;
    (c.items || []).forEach(function (li) {
      if (skip[li.variant_id] || addon[li.product_id]) return;
      coreCount += li.quantity;
      coreSubtotal += li.final_line_price;
    });
    return { coreCount: coreCount, coreSubtotal: coreSubtotal };
  }

  /* Why checkout is blocked, or null when it's fine. */
  function checkoutBlock(c) {
    var r = CFG.checkoutRules || {};
    var shape = cartShape(c);
    if (r.requireProduct !== false && shape.coreCount === 0) {
      return r.message || 'Add a product to your cart before checking out.';
    }
    if (r.minOrder > 0 && shape.coreSubtotal < r.minOrder) {
      return 'Orders start at ' + fmt(r.minOrder) + '. Add ' +
             fmt(r.minOrder - shape.coreSubtotal) + ' more to check out.';
    }
    return null;
  }

  function giftIcon() {
    return '<svg viewBox="0 0 24 24"><rect x="3.5" y="8.5" width="17" height="12" rx="1.5"/>' +
      '<path d="M3.5 12.5h17M12 8.5v12"/></svg>';
  }

  function shieldIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 3l7 3v5.2c0 4.4-2.9 8.3-7 9.8-4.1-1.5-7-5.4-7-9.8V6l7-3z"/>' +
      '<path d="M9.2 12.2l2 2 3.6-3.9"/></svg>';
  }

  function renderCart() {
    if (!cart) return;
    var body = $('#ac-cartBody'), foot = $('#ac-cartFoot'), rw = $('#ac-rw');
    var ct = $('#ac-cartCt');
    if (ct) ct.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');

    /* reward ladder — measured on the products, excluding gifts and the protection fee */
    var sub = qualifyingSubtotal(cart);
    var ladder = CFG.rewards || [];
    if (rw && ladder.length) {
      var next = null;
      for (var i = 0; i < ladder.length; i++) { if (sub < ladder[i].threshold) { next = ladder[i]; break; } }
      var top = ladder[ladder.length - 1].threshold;
      var pct = Math.min(100, (sub / top) * 100);
      var wasOpen = rw.classList.contains('open');
      rw.className = 'ac-rw' + (wasOpen ? ' open' : '');
      var hitCount = ladder.filter(function (r) { return sub >= r.threshold; }).length;
      var prevAt = 0;
      var segments = ladder.map(function (r, i) {
        /* each segment fills independently between its own start and end */
        var span = r.threshold - prevAt;
        var into = Math.min(Math.max(sub - prevAt, 0), span);
        var fill = span > 0 ? (into / span) * 100 : 100;
        prevAt = r.threshold;
        var done = sub >= r.threshold;
        return '<div class="ac-seg ' + (done ? 'done' : '') + '">' +
                 '<span class="sg"><i style="width:' + fill + '%"></i></span>' +
                 '<span class="sy" aria-hidden="true">' + (r.symbol || '★') + '</span>' +
                 '<span class="sa">' + fmt(r.threshold) + '</span>' +
               '</div>';
      }).join('');

      /* Nothing left to chase — the ladder stops taking up a third of the screen and
         becomes one line. Tap it to see the full list. */
      var allDone = !next;
      if (allDone) rw.className += ' done';

      rw.innerHTML =
        '<div class="ac-rl"><div>' +
          (next
            ? 'You\'re <b>' + fmt(next.threshold - sub) + '</b> from ' + esc(next.label.toLowerCase())
            : 'Everything unlocked — nice work') +
        '</div><div class="ac-rt2">' + hitCount + ' / ' + ladder.length + '</div></div>' +
        (allDone ? '' : '<div class="ac-segs">' + segments + '</div>') +
        '<div class="ac-rwlist">' + ladder.map(function (r) {
          var hit = sub >= r.threshold;
          return '<div class="ac-rwi ' + (hit ? 'hit' : '') + '"><span class="dot">' +
            (hit ? '✓' : (r.symbol || '')) + '</span><span>' + esc(r.label) +
            (r.code && hit ? ' <em class="ac-code">' + esc(r.code) + '</em>' : '') +
            '</span><span class="amt">' + fmt(r.threshold) + '</span></div>';
        }).join('') + '</div>';
    }

    if (!cart.items.length) {
      body.innerHTML = '<div class="ac-empty"><div class="em">\u{1F525}</div>' +
        '<p style="font-size:15px;margin-bottom:16px">Nothing in the cart yet.</p>' +
        '<a class="ac-btn ac-btn--p ac-btn--sm" href="' + CFG.shopAllUrl + '">Browse lighters</a></div>';
      foot.innerHTML = '';
      return;
    }

    var giftIds = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) giftIds[g.variant] = g.label; });
    var protId = CFG.protection && CFG.protection.variant;

    var skipIds = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) skipIds[g.variant] = true; });
    if (CFG.protection && CFG.protection.variant) skipIds[CFG.protection.variant] = true;
    var addonIds = {};
    (CFG.addons || []).forEach(function (a) { addonIds[a.id] = true; });
    var qualifyingQty = cart.items.reduce(function (n, li) {
      return (skipIds[li.variant_id] || addonIds[li.product_id]) ? n : n + li.quantity;
    }, 0);
    var nextTier = null;
    (CFG.tiers || []).forEach(function (t) {
      if (qualifyingQty < t.qty && (!nextTier || t.qty < nextTier.qty)) nextTier = t;
    });
    var nudgeShown = false;

    var html = '';
    cart.items.forEach(function (li) {
      if (li.variant_id === protId) return;                       // shown as its own toggle row
      if (giftIds[li.variant_id]) {
        /* One tight line. The subtitle said nothing the word FREE doesn't. */
        html += '<div class="ac-freeline"><div class="fi">' + giftIcon() + '</div>' +
          '<b>' + esc(li.product_title) + '</b><div class="fp">FREE</div></div>';
        return;
      }
      var lineTotal = li.final_line_price;
      var wasTotal = li.original_line_price;
      var tierNudge = '';
      var isAddon = addonIds[li.product_id];
      if (!isAddon && !nudgeShown && nextTier) {
        var need = nextTier.qty - qualifyingQty;
        tierNudge = '<span class="ac-nudge">+' + need + ' more lighter' + (need > 1 ? 's' : '') +
          ' → save ' + nextTier.percent + '%</span>';
        nudgeShown = true;
      }
      var variantLine = li.variant_title && li.variant_title !== 'Default Title' ? esc(li.variant_title) : '';
      html += '<div class="ac-line">' +
        '<div class="lp">' + (li.image ? '<img src="' + li.image + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="li">' +
          '<div class="ln">' + esc(li.product_title) + '</div>' +
          (variantLine ? '<div class="lv">' + variantLine + '</div>' : '') +
          tierNudge +
          /* Stepper, Remove and price share one row — Remove used to sit on a line of
             its own, which cost ~20px on every item in the cart. */
          '<div class="lb"><div class="ac-step">' +
            '<button data-ac-qty="' + li.key + '" data-d="-1" aria-label="Decrease quantity">−</button>' +
            '<span>' + li.quantity + '</span>' +
            '<button data-ac-qty="' + li.key + '" data-d="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button class="rm" data-ac-rm="' + li.key + '">Remove</button>' +
          '<div class="lx">' +
            (wasTotal > lineTotal ? '<span class="lwas">' + fmt(wasTotal) + '</span>' : '') +
            '<span class="lpr">' + fmt(lineTotal) + '</span>' +
          '</div></div>' +
        '</div></div>';
    });

    /* upsell rail — products injected by Liquid, minus what's already in the cart */
    var inCart = {};
    cart.items.forEach(function (l) { inCart[l.product_id] = true; });
    var recs = (CFG.upsells || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 6);
    if (recs.length) {
      /* Open when there's room to browse, shut once the cart is full of real items —
         a busy cart shouldn't have an upsell rail sitting on top of it. */
      var openRail = qualifyingQty <= 2 ? ' open' : '';
      html += '<details class="ac-crow"' + openRail + '><summary><span style="font-weight:600">Add to your order</span>' +
        '<span style="font-size:12.5px;color:var(--ac-text3);margin-left:6px">one tap</span></summary>' +
        '<div class="ac-cc"><div class="ac-upsells">' + recs.map(function (p) {
          return '<div class="ac-up"><img src="' + p.image + '" alt="" loading="lazy"><div class="ub">' +
            '<div class="un">' + esc(p.title) + '</div><div class="upp">' + fmt(p.price) + '</div>' +
            '<button class="add" data-ac-add="' + p.variant + '">Add</button></div></div>';
        }).join('') + '</div></div></details>';
    }

    /* spares */
    var addons = (CFG.addons || []).filter(function (a) { return !inCart[a.id]; });
    if (addons.length) {
      html += '<details class="ac-crow"><summary><span style="font-weight:600">Wicks, flints &amp; spares</span></summary>' +
        '<div class="ac-cc">' + addons.map(function (a) {
          return '<button class="ac-ao" style="border:0;padding:10px 0;min-height:48px" data-ac-add="' + a.variant + '">' +
            '<span class="ac-ai">' + (a.image ? '<img src="' + a.image + '" alt="">' : giftIcon()) + '</span>' +
            '<span class="ac-an"><b>' + esc(a.title) + '</b><span>' + esc(a.subtitle || '') + '</span></span>' +
            '<span class="ac-ap">' + fmt(a.price) + '</span></button>';
        }).join('') + '</div></details>';
    }

    /* discount code */
    html += '<details class="ac-crow"><summary><span style="font-weight:600">Have a discount code?</span></summary>' +
      '<div class="ac-cc"><div class="ac-codebox">' +
      '<input id="ac-code" placeholder="Enter code" autocomplete="off" aria-label="Discount code">' +
      '<button class="ac-btn ac-btn--s ac-btn--sm" id="ac-codeBtn">Apply</button></div>' +
      '<div style="font-size:12px;color:var(--ac-text3);margin-top:8px">Applied at checkout.</div></div></details>';

    body.innerHTML = html;

    /* Highest unlocked tier that hands out a code — it rides to checkout on the URL. */
    var unlockedCode = null, unlockedLabel = '';
    ladder.forEach(function (r) {
      if (r.code && sub >= r.threshold) { unlockedCode = r.code; unlockedLabel = r.label; }
    });
    var checkoutHref = '/checkout' + (unlockedCode ? '?discount=' + encodeURIComponent(unlockedCode) : '');

    var blocked = checkoutBlock(cart);

    /* Subtotal is shown BEFORE discounts so the discount row isn't double-counted. */
    var gross = cart.original_total_price;
    var savings = gross - cart.total_price;

    /* Shipping protection — pinned just above the totals, like a dedicated cart app.
       If no product is set in Theme settings there is nothing to add, so the row can't
       render; in the theme editor we say so out loud instead of hiding silently. */
    var protRow = '';
    if (protId) {
      var on = protectOn();
      protRow = '<button class="ac-prot" id="ac-protBtn" aria-pressed="' + on + '">' +
        '<span class="ac-pico">' + shieldIcon() + '</span>' +
        '<span class="pt"><b>' + esc(CFG.protection.title || 'Shipping protection') +
        '<span class="pp2">' + fmt(CFG.protection.price || 0) + '</span></b>' +
        '<span>' + esc(CFG.protection.subtitle || 'Covers loss, theft or damage in transit') + '</span></span>' +
        '<span class="ac-tog"><i></i></span></button>';
    } else if (CFG.designMode) {
      protRow = '<div class="ac-hint">Shipping protection is off because no product is chosen. ' +
        'Theme settings → AllureCart → Shipping protection product. Only you can see this note.</div>';
    }

    foot.innerHTML = protRow +
      '<div class="ac-sum"><span>Subtotal</span><span class="v">' + fmt(gross) + '</span></div>' +
      (savings > 0 ? '<div class="ac-sum"><span>Bundle &amp; discounts</span><span class="v" style="color:var(--ac-good)">−' +
        fmt(savings) + '</span></div>' : '') +
      '<div class="ac-sum"><span>Shipping</span><span class="v ' +
        (sub >= (CFG.freeShipThreshold || 0) ? 'free">FREE' : '">Calculated at checkout') + '</span></div>' +
      '<div class="ac-sum tot"><span>Total</span><span class="v">' + fmt(cart.total_price) + '</span></div>' +
      (unlockedCode
        ? '<div class="ac-sum ac-codeline"><span>' + esc(unlockedLabel) +
          '</span><span class="v">at checkout</span></div>'
        : '') +
      (blocked
        ? '<div class="ac-blocked" role="alert">' + esc(blocked) + '</div>' +
          '<button class="ac-btn ac-btn--p ac-btn--blk" disabled>Checkout</button>'
        : '<a class="ac-btn ac-btn--p ac-btn--blk" href="' + checkoutHref + '">Checkout · ' +
          fmt(cart.total_price) + '</a>') +
      '<div class="ac-pays"><span>VISA</span><span>MASTERCARD</span><span>AMEX</span><span>PAYPAL</span>' +
        '<span>APPLE PAY</span><span>SHOP PAY</span></div>';
  }

  /* ---------- delegated drawer events ---------- */
  document.addEventListener('click', function (e) {
    var el;

    if ((el = e.target.closest('[data-ac-open-cart]'))) { e.preventDefault(); refresh(true); return; }
    if ((el = e.target.closest('[data-ac-close-cart]'))) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.id === 'ac-scrim') { closeDrawer(); closeChat(); return; }
    if ((el = e.target.closest('#ac-rw'))) { el.classList.toggle('open'); return; }

    if ((el = e.target.closest('[data-ac-qty]'))) {
      if (busy) return; busy = true;
      var key = el.getAttribute('data-ac-qty');
      var line = cart.items.filter(function (l) { return l.key === key; })[0];
      var q = Math.max(0, line ? line.quantity + Number(el.getAttribute('data-d')) : 0);
      /* Show the new number on the tap. change.js hands back the whole cart, so this
         is a single round trip and the totals catch up a moment later. */
      var out = el.parentNode.querySelector('span');
      if (out) out.textContent = q;
      setBusy(true);
      changeLine(key, q).then(function (c) {
        if (c && c.items) { paintCart(c); return reconcile(c).then(function (c2) {
          if (c2 !== c) paintCart(c2);
        }); }
        return refresh();
      }).then(function () { setBusy(false); busy = false; },
              function () { setBusy(false); busy = false; refresh(); });
      return;
    }
    if ((el = e.target.closest('[data-ac-rm]'))) {
      if (busy) return; busy = true;
      var row = el.closest('.ac-line');
      if (row) row.style.opacity = '.35';
      setBusy(true);
      changeLine(el.getAttribute('data-ac-rm'), 0).then(function (c) {
        if (c && c.items) { paintCart(c); return reconcile(c).then(function (c2) {
          if (c2 !== c) paintCart(c2);
        }); }
        return refresh();
      }).then(function () { setBusy(false); busy = false; },
              function () { setBusy(false); busy = false; refresh(); });
      return;
    }
    if ((el = e.target.closest('[data-ac-add]'))) {
      if (busy) return; busy = true;
      el.textContent = 'Adding…';
      setBusy(true);
      addItems2([{ id: Number(el.getAttribute('data-ac-add')), quantity: 1 }])
        .then(function (c) {
          if (!c || !c.items) return refresh();
          paintCart(c);
          return reconcile(c).then(function (c2) { if (c2 !== c) paintCart(c2); });
        })
        .then(function () { setBusy(false); busy = false; },
              function () { setBusy(false); busy = false; refresh(); });
      return;
    }
    if (e.target.id === 'ac-protBtn' || e.target.closest('#ac-protBtn')) {
      if (busy) return; busy = true;
      setProtect(!protectOn());
      refresh().then(function () { busy = false; }, function () { busy = false; });
      return;
    }
    if (e.target.id === 'ac-codeBtn') {
      var code = ($('#ac-code').value || '').trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + CFG.routes.cart_url;
      return;
    }
  });

  /* ---------- product page ---------- */
  function initPDP() {
    var root = $('#ac-pdp'); if (!root) return;
    var data = JSON.parse($('#ac-product-json').textContent);
    var byId = {};
    data.variants.forEach(function (v) { byId[v.id] = v; });

    var gallery = data.images || [];

    /* Shopify only gives a variant its own image if one was assigned there.
       When it wasn't, match on the image's alt text — "007 Silver", "Gold", etc. */
    function imageForVariant(v) {
      if (v.featured_image) return v.featured_image;
      var name = String(v.title).split(' / ')[0].trim().toLowerCase();
      if (!name || name === 'default title') return null;
      var hit = gallery.filter(function (g) {
        return String(g.alt || '').toLowerCase().indexOf(name) !== -1;
      })[0];
      return hit ? hit.url : null;
    }
    function showImage(url) {
      if (!url) return;
      var main = $('#ac-galMain');
      if (main) main.src = url;
      $$('[data-ac-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', String(b.getAttribute('data-ac-thumb') === url));
      });
    }

    var first = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
    var state = { variant: first, preview: first, qty: 1, units: [first.id], addons: {}, pairs: {} };

    function tierFor(q) {
      var t = null;
      (CFG.tiers || []).forEach(function (x) { if (q >= x.qty) t = x; });
      return t;
    }
    function tierPct() { var t = tierFor(state.qty); return t ? t.percent / 100 : 0; }

    /* keep one entry per unit; new slots inherit the headline finish */
    function syncUnits() {
      while (state.units.length < state.qty) state.units.push(state.variant.id);
      state.units.length = state.qty;
    }
    function unitsSubtotal() {
      return state.units.reduce(function (sum, id) {
        var v = byId[id] || state.variant;
        return sum + Math.round(v.price * (1 - tierPct()));
      }, 0);
    }
    function extrasSubtotal() {
      var sum = 0;
      Object.keys(state.addons).forEach(function (k) { if (state.addons[k]) sum += Number(k.split('|')[1]); });
      Object.keys(state.pairs).forEach(function (k) { if (state.pairs[k]) sum += Number(k.split('|')[1]); });
      return sum;
    }

    /* per-unit finish pickers — only meaningful above quantity 1 */
    function renderMulti() {
      var box = $('#ac-multi'); if (!box) return;
      if (state.qty < 2) { box.hidden = true; box.innerHTML_rows = null; return; }
      box.hidden = false;
      var rows = $('#ac-multiRows'); if (!rows) return;
      rows.innerHTML = state.units.map(function (id, i) {
        return '<div class="ac-mrow"><span class="n">#' + (i + 1) + '</span>' +
          '<select data-ac-unit="' + i + '" aria-label="Finish for item ' + (i + 1) + '">' +
          data.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.id === id ? ' selected' : '') +
              (v.available ? '' : ' disabled') + '>' + esc(v.title) +
              (v.available ? '' : ' — sold out') + '</option>';
          }).join('') + '</select></div>';
      }).join('');
    }

    function paint() {
      syncUnits();
      var t = tierFor(state.qty);
      var perUnit = Math.round(state.variant.price * (1 - tierPct()));
      /* Guarded: one missing node used to throw here, which killed every PDP click
         handler on that page — including the buy buttons. */
      var now = $('#ac-nowPrice'); if (now) now.textContent = fmt(perUnit);

      var cmp = $('#ac-cmpPrice');
      if (cmp) {
        var showCmp = state.variant.compare_at_price > state.variant.price;
        cmp.style.display = showCmp ? '' : 'none';
        if (showCmp) cmp.textContent = fmt(state.variant.compare_at_price);
      }
      var badge = $('#ac-saveBadge');
      if (badge) {
        var off = state.variant.compare_at_price > state.variant.price
          ? Math.round((1 - state.variant.price / state.variant.compare_at_price) * 100) : 0;
        var parts = [];
        if (off) parts.push('SAVE ' + off + '%');
        if (t) parts.push('BUNDLE −' + t.percent + '%');
        badge.textContent = parts.join(' + ');
        badge.style.display = parts.length ? '' : 'none';
      }

      $$('[data-ac-variant]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-ac-variant')) === state.variant.id));
      });
      $$('[data-ac-qtytier]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-ac-qtytier')) === state.qty));
      });

      var lbl = $('#ac-variantLabel');
      if (lbl) {
        var showing = (state.preview || state.variant);
        lbl.textContent = showing.title +
          (showing.id !== state.variant.id ? ' (showing)' : '');
      }
      var qlbl = $('#ac-qtyLabel');
      if (qlbl) {
        var mixed = state.qty > 1 && state.units.some(function (id) { return id !== state.units[0]; });
        qlbl.textContent = state.qty === 1 ? 'Single' : (state.qty + ' pieces' + (mixed ? ' · mixed' : ''));
      }

      renderMulti();

      var grand = unitsSubtotal() + extrasSubtotal();
      var btn = $('#ac-addBtn');
      var anyAvailable = state.units.every(function (id) { return (byId[id] || {}).available; });
      if (btn) {
        btn.disabled = !anyAvailable;
        btn.textContent = anyAvailable ? 'Add to cart · ' + fmt(grand) : 'Sold out';
      }

      var sp = $('#ac-stickyPrice'); if (sp) sp.textContent = fmt(grand);
      var sq = $('#ac-stickyQty');
      if (sq) {
        var extras = Object.keys(state.addons).filter(function (k) { return state.addons[k]; }).length +
                     Object.keys(state.pairs).filter(function (k) { return state.pairs[k]; }).length;
        sq.textContent = (state.qty > 1 ? state.qty + ' pcs' : '1 pc') + (extras ? ' + ' + extras : '');
      }

      showImage(imageForVariant(state.preview || state.variant));
    }

    /* changing a single unit's finish */
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-ac-unit]');
      if (!sel) return;
      var chosen = Number(sel.value);
      state.units[Number(sel.getAttribute('data-ac-unit'))] = chosen;
      /* show what they just picked, so the photo always matches the last choice */
      state.preview = byId[chosen] || state.preview;
      paint();
    });

    /* Bound to the document, not to #ac-pdp: the sticky buy bar is a SIBLING of that
       element, so a click on it never bubbled through here and the button did nothing. */
    document.addEventListener('click', function (e) {
      var el;
      if ((el = e.target.closest('[data-ac-variant]'))) {
        var id = Number(el.getAttribute('data-ac-variant'));
        state.variant = byId[id] || state.variant;
        state.preview = state.variant;
        state.units = state.units.map(function () { return state.variant.id; });   // headline choice resets all
        paint(); return;
      }
      if ((el = e.target.closest('[data-ac-qtytier]'))) {
        state.qty = Number(el.getAttribute('data-ac-qtytier'));
        state.preview = state.variant;
        paint(); return;
      }
      if ((el = e.target.closest('[data-ac-addon]'))) {
        var k = el.getAttribute('data-ac-addon');
        state.addons[k] = !state.addons[k];
        el.setAttribute('aria-pressed', String(!!state.addons[k])); paint(); return;
      }
      if ((el = e.target.closest('[data-ac-pair]'))) {
        var pk = el.getAttribute('data-ac-pair');
        state.pairs[pk] = !state.pairs[pk];
        el.setAttribute('aria-pressed', String(!!state.pairs[pk])); paint(); return;
      }
      if ((el = e.target.closest('[data-ac-thumb]'))) {
        $('#ac-galMain').src = el.getAttribute('data-ac-thumb');
        $$('[data-ac-thumb]').forEach(function (b) { b.setAttribute('aria-current', String(b === el)); });
        return;
      }
      if (e.target.closest('#ac-addBtn') || e.target.closest('#ac-stickyAdd')) {
        if (busy) return; busy = true;
        var srcBtn = e.target.closest('#ac-addBtn') || e.target.closest('#ac-stickyAdd');
        var srcLabel = srcBtn.textContent;
        srcBtn.textContent = 'Adding…';
        var restore = function () { srcBtn.textContent = srcLabel; };

        /* group the chosen units so 2 × Silver is one line, Silver + Gold is two */
        var counts = {};
        state.units.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
        var items = Object.keys(counts).map(function (id) {
          return { id: Number(id), quantity: counts[id] };
        });
        Object.keys(state.addons).forEach(function (k) { if (state.addons[k]) items.push({ id: Number(k.split('|')[0]), quantity: 1 }); });
        Object.keys(state.pairs).forEach(function (k) { if (state.pairs[k]) items.push({ id: Number(k.split('|')[0]), quantity: 1 }); });

        openDrawer();                                // on the tap, before any network
        setBusy(true);
        addItems2(items).then(function (res) {
          if (res && res.status && res.description) {
            toast(res.description); restore(); closeDrawer(); setBusy(false); busy = false; return;
          }
          state.addons = {}; state.pairs = {};
          $$('[data-ac-addon],[data-ac-pair]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          paint();                                   // paint() rewrites #ac-addBtn's own label
          if (srcBtn.id === 'ac-stickyAdd') restore();
          if (!res || !res.items) return refresh(true);
          paintCart(res);
          return reconcile(res).then(function (c2) { if (c2 !== res) paintCart(c2); });
        }).then(function () { setBusy(false); busy = false; },
                function () { restore(); setBusy(false); busy = false; refresh(true); });
        return;
      }
    });

    var sticky = $('#ac-sticky');
    if (sticky) {
      var onScroll = function () {
        var show = window.scrollY > 420;
        sticky.classList.toggle('on', show);
        var cb = $('#ac-chatBtn');
        if (cb) cb.classList.toggle('hide', show && window.innerWidth < 900);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    paint();
  }

  /* ---------- rewards modal ---------- */
  var rwTab = 'earn';
  function icon(name) {
    var p = {
      join: '<path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z"/>',
      order: '<path d="M5.5 8h13l-1.2 11.2a2 2 0 01-2 1.8H8.7a2 2 0 01-2-1.8z"/><path d="M9 8V6.2a3 3 0 116 0V8"/>',
      social: '<rect x="4" y="4" width="16" height="16" rx="4.5"/><circle cx="12" cy="12" r="3.4"/><circle cx="17" cy="7" r="1"/>',
      tiktok: '<path d="M14 4v9.6a3.4 3.4 0 11-2.6-3.3"/><path d="M14 4c.4 2.3 1.9 3.7 4.2 3.9"/>',
      review: '<path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z"/>',
      cake: '<path d="M4 20h16v-6H4z"/><path d="M4 14c2 0 2-1.5 4-1.5S10 14 12 14s2-1.5 4-1.5S18 14 20 14"/><path d="M12 9V5"/>',
      money: '<rect x="3" y="7" width="18" height="10" rx="2"/><circle cx="12" cy="12" r="2.5"/>',
      gift: '<rect x="3.5" y="8.5" width="17" height="12" rx="1.5"/><path d="M3.5 12.5h17M12 8.5v12"/>',
      truck: '<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/>'
    };
    return '<svg viewBox="0 0 24 24">' + (p[name] || p.join) + '</svg>';
  }

  /* The popup's content comes from the "Popup — rewards or email" section in the
     footer group, so every word of it is editable in the theme editor. Theme
     settings are only a fallback for a theme that predates that section. */
  function pop() {
    /* No section means no popup — removing it from the footer group is how you turn it off. */
    return window.ACRewards && window.ACRewards.mode ? window.ACRewards : { mode: 'off', launchers: false };
  }
  function openRewards(tab, forceSuccess) {
    var R = pop();
    if (R.mode === 'off' && !R.designMode) return;
    rwTab = tab || 'earn';
    var m = $('#ac-modal');
    var joined = forceSuccess === true;
    if (!joined) { try { joined = localStorage.getItem('ac_member') === '1'; } catch (e) {} }

    var head = joined
      ? '<h3 class="ac-disp" style="margin-top:6px">' + esc(R.successHeading || "You're in") + '</h3>' +
        '<p class="ac-sp">' + esc(R.successBody || '') + '</p>' +
        (R.code
          ? '<button class="ac-codechip" id="ac-copyCode" data-code="' + esc(R.code) + '">' +
            '<span class="cl">Your code</span><b>' + esc(R.code) + '</b><span class="cc">Tap to copy</span></button>'
          : '')
      : '<h3 class="ac-disp" style="margin-top:6px">' + esc(R.heading || '') +
          (R.accent ? ' <em>' + esc(R.accent) + '</em>' : '') + '</h3>' +
        '<p class="ac-sp">' + esc(R.body || '') + '</p>' +
        '<form id="ac-joinForm" method="post" action="/contact#ac-join" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="' + esc(R.tags || 'newsletter') + '">' +
        '<input type="email" name="contact[email]" required placeholder="your@email.com" autocomplete="email">' +
        '<button class="ac-btn ac-btn--p ac-btn--blk" type="submit">' + esc(R.buttonLabel || 'Sign up') + '</button>' +
        '</form>' +
        (R.footnote ? '<p class="ac-fine">' + esc(R.footnote) + '</p>' : '') +
        '<button class="ac-skip" data-ac-close-modal>' + esc(R.declineLabel || 'No thanks') + '</button>';

    /* The tabs, points and tiers are the rewards programme. Email mode is just the offer. */
    var body = '';
    if (R.mode === 'rewards') {
      var L = R.tabLabels || {};
      body = '<div class="ac-rwtabs" role="tablist" style="margin-top:' + (joined ? '4px' : '20px') + '">' +
        ['earn', 'vip', 'ref'].map(function (t) {
          var lbl = t === 'earn' ? (L.earn || 'Ways to earn') : t === 'vip' ? (L.vip || 'VIP tiers') : (L.ref || 'Refer');
          return '<button role="tab" aria-selected="' + (rwTab === t) + '" data-ac-rwtab="' + t + '">' + esc(lbl) + '</button>';
        }).join('') + '</div>' +
        (rwTab === 'earn'
          ? (R.earn || []).map(function (x) {
              return '<div class="ac-earn"><span class="ei">' + icon(x.icon) + '</span>' +
                '<span class="en"><b>' + esc(x.name) + '</b><span>' + esc(x.note) + '</span></span>' +
                '<span class="ep">' + esc(x.points) + '</span></div>';
            }).join('')
          : rwTab === 'vip'
          ? (R.vip || []).map(function (t) {
              return '<div class="ac-vip ' + (t.gold ? 'gold' : '') + '"><div class="vh">' +
                '<span class="vn">' + esc(t.name) + '</span><span class="vp">' + esc(t.at) + '</span></div><ul>' +
                (t.perks || []).map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul></div>';
            }).join('')
          : '<div class="ac-vip"><div class="vh"><span class="vn">' + esc(R.referTitle || '') +
            '</span></div><ul>' + (R.refer || []).map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') +
            '</ul></div>');
    }

    var editorNote = (R.mode === 'off' && R.designMode)
      ? '<div class="ac-hint" style="margin:14px 0 0">The popup is switched off, so shoppers never see this. ' +
        'Turn it back on under Footer, in the section called Popup — rewards or email.</div>' : '';

    m.innerHTML = '<div class="ac-sheet"><button class="x" data-ac-close-modal aria-label="Close">✕</button>' +
      (R.image ? '<div class="ac-shero"><img src="' + R.image + '" alt=""></div>' : '') +
      '<div class="ac-sb">' + (R.eyebrow ? '<div class="ac-eyebrow">' + esc(R.eyebrow) + '</div>' : '') +
      head + body + editorNote + '</div></div>';
    m.classList.add('on');
    document.body.classList.add('ac-locked');
    var f = $('#ac-joinForm');
    if (f) f.addEventListener('submit', function () { try { localStorage.setItem('ac_member', '1'); } catch (e) {} });
  }
  function closeModal() {
    $('#ac-modal').classList.remove('on');
    if (!drawerOpen()) document.body.classList.remove('ac-locked');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ac-rewards]')) { e.preventDefault(); openRewards(); return; }
    if (e.target.closest('[data-ac-close-modal]')) { e.preventDefault(); closeModal(); return; }
    var cc = e.target.closest('#ac-copyCode');
    if (cc) {
      e.preventDefault();
      var code = cc.getAttribute('data-code') || '';
      var done = function () { var s = cc.querySelector('.cc'); if (s) s.textContent = 'Copied'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(ta); done();
      }
      return;
    }
    var t = e.target.closest('[data-ac-rwtab]');
    if (t) { openRewards(t.getAttribute('data-ac-rwtab')); return; }
    if (e.target.id === 'ac-modal') closeModal();
  });

  /* ---------- concierge chat ---------- */
  var chatCtx = null;
  function openChat() {
    chatCtx = window.ACProduct || null;
    $('#ac-chat').classList.add('on');
    $('#ac-scrim').classList.add('on');
    var b = $('#ac-chatBody'); b.innerHTML = '';
    if (chatCtx) {
      say('bot', 'You\'re looking at the ' + chatCtx.title + '. ' + (chatCtx.blurb || '') +
        ' It\'s ' + fmt(chatCtx.price) + (chatCtx.options && chatCtx.options.length > 1
          ? ' in ' + chatCtx.options.join(', ').replace(/, ([^,]*)$/, ' and $1') : '') + '.');
      if (chatCtx.specs && chatCtx.specs.length) say('bot', chatCtx.specs.map(function (s) { return '• ' + s; }).join('\n'));
    } else {
      say('bot', 'Hi — I can talk you through any lighter, or answer anything about shipping, fuel and bundles. What are you after?');
    }
    chips();
  }
  function closeChat() {
    $('#ac-chat').classList.remove('on');
    if (!drawerOpen()) $('#ac-scrim').classList.remove('on');
  }
  function say(who, text) {
    var b = $('#ac-chatBody');
    var d = document.createElement('div');
    d.className = 'ac-msg ' + who;
    d.textContent = text;
    b.appendChild(d);
    b.scrollTop = b.scrollHeight;
  }
  function chips() {
    var c = $('#ac-chatChips');
    var base = chatCtx
      ? [['Is it heavy?', 'weight'], ['How do I refill it?', 'fuel'], ['Bundle deal?', 'bundle'], ['Delivery time?', 'shipping']]
      : [['What\'s your bestseller?', 'best'], ['Delivery time?', 'shipping'], ['Does it come with fuel?', 'fuel'],
         ['Bundle deal?', 'bundle'], ['Returns?', 'returns']];
    c.innerHTML = base.map(function (x) {
      return '<button class="ac-chip" data-ac-ask="' + x[1] + '">' + x[0] + '</button>';
    }).join('');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ac-chat]')) { e.preventDefault(); openChat(); return; }
    if (e.target.closest('[data-ac-close-chat]')) { e.preventDefault(); closeChat(); return; }
    var a = e.target.closest('[data-ac-ask]');
    if (!a) return;
    var key = a.getAttribute('data-ac-ask');
    say('me', a.textContent);
    setTimeout(function () {
      var ans = (CFG.chatAnswers || {})[key];
      if (key === 'weight' && chatCtx && chatCtx.specs && chatCtx.specs[0]) {
        ans = 'The ' + chatCtx.title + ' is a solid-body piece — ' + chatCtx.specs[0].toLowerCase() +
          '. It has real weight to it; that\'s usually the first thing people mention.';
      }
      say('bot', ans || 'Good question — email ' + (CFG.supportEmail || 'us') + ' and a human will answer within the hour.');
    }, 380);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeChat(); closeModal(); }
  });

  /* Dawn's standalone /cart page has its own checkout button — hold it to the same rule. */
  function gateCartPage() {
    if (!cart) return;
    var msg = checkoutBlock(cart);
    $$('[name="checkout"], .cart__checkout-button').forEach(function (btn) {
      btn.disabled = !!msg;
      btn.setAttribute('aria-disabled', String(!!msg));
      var note = btn.parentNode && btn.parentNode.querySelector('.ac-blocked');
      if (msg && !note) {
        note = document.createElement('div');
        note.className = 'ac-blocked';
        btn.parentNode.insertBefore(note, btn);
      }
      if (note) { note.textContent = msg || ''; note.style.display = msg ? '' : 'none'; }
    });
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initPDP();
    refresh().then(gateCartPage);
    var R = pop();

    /* Launcher buttons take their wording from the same section, and disappear with it. */
    $$('[data-ac-rewards]').forEach(function (b) {
      if (!R.launchers || R.mode === 'off') { b.style.display = 'none'; return; }
      var s = b.querySelector('span');
      if (s && R.launcherLabel) s.textContent = R.launcherLabel;
      if (b.classList.contains('ac-ico')) b.setAttribute('aria-label', R.launcherLabel || 'Rewards');
      else if (!s && R.launcherLabel) {
        /* tab-bar button: the label is a bare text node after the icon */
        var n = b.lastChild;
        if (n && n.nodeType === 3) n.nodeValue = R.launcherLabel.toUpperCase();
      }
    });

    /* Shopify posts the signup form and reloads with customer_posted=true.
       That's our only chance to show the code, so reopen straight into success. */
    if (location.search.indexOf('customer_posted=true') > -1) {
      try { localStorage.setItem('ac_member', '1'); localStorage.setItem('ac_rw', '1'); } catch (e) {}
      openRewards('earn', true);
    }

    var delay = Number(R.delay || 0);
    if (delay > 0 && R.mode !== 'off') {
      setTimeout(function () {
        var seen = false, member = false;
        try { seen = localStorage.getItem('ac_rw') === '1'; member = localStorage.getItem('ac_member') === '1'; } catch (e) {}
        if (!seen && !member && !drawerOpen() && !$('#ac-modal').classList.contains('on')) {
          openRewards();
          try { localStorage.setItem('ac_rw', '1'); } catch (e) {}
        }
      }, delay * 1000);
    }
  });

  window.AllureCart = { refresh: refresh, openCart: function () { refresh(true); }, openRewards: openRewards, openChat: openChat };
})();
